var map = {
	"./acr.png": "d920",
	"./addi.png": "4e5e",
	"./daviplata.png": "1fb0",
	"./didi.png": "3fef",
	"./nequi.png": "d48a",
	"./rappi.png": "39df",
	"./sistecredito.png": "2f28",
	"./wompi.png": "fa79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "18cb";